window.disableProductImageSlider = true;

(function() {
  if (window.productImageSliderInitialized) return;
  window.productImageSliderInitialized = true;

  if (window.innerWidth >= 960) return;

  const SWIPE_THRESHOLD = 50;
  const TRANSITION_DURATION = 300;

  let touchStartX = 0;
  let touchStartY = 0;
  let isDragging = false;
  let currentElement = null;

  function handleTouchStart(e) {
    if (window.disableProductImageSlider) return;
    
    const imageContainer = e.target.closest('.product-grid-item__image--secondary');
    if (!imageContainer) return;

    currentElement = imageContainer;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = true;
  }

  function handleTouchMove(e) {
    if (window.disableProductImageSlider) return;
    if (!isDragging || !currentElement) return;

    const touchCurrentX = e.touches[0].clientX;
    const touchCurrentY = e.touches[0].clientY;
    const diffX = touchCurrentX - touchStartX;
    const diffY = touchCurrentY - touchStartY;

    if (Math.abs(diffY) > Math.abs(diffX)) {
      return;
    }

    e.preventDefault();
  }

  function handleTouchEnd(e) {
    if (window.disableProductImageSlider) return;
    if (!isDragging || !currentElement) return;

    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const diffX = touchEndX - touchStartX;
    const diffY = touchEndY - touchStartY;

    if (Math.abs(diffY) > Math.abs(diffX)) {
      isDragging = false;
      currentElement = null;
      return;
    }

    const primaryImage = currentElement.querySelector('.new-pc-img');
    const secondaryImage = currentElement.querySelector('.secondary-image');
    const paginationDots = currentElement.querySelectorAll('.pagination-dot-cont');
    
    if (!primaryImage || !secondaryImage || paginationDots.length !== 2) {
      isDragging = false;
      currentElement = null;
      return;
    }

    const isSecondaryVisible = parseFloat(getComputedStyle(secondaryImage).opacity) > 0.5;

    if (diffX < -SWIPE_THRESHOLD) {
      if (!isSecondaryVisible) {
        slideImages(primaryImage, secondaryImage, 'left');
        updatePaginationDots(paginationDots, 1);
      } else {
        slideImages(secondaryImage, primaryImage, 'left');
        updatePaginationDots(paginationDots, 0);
      }
    }
    else if (diffX > SWIPE_THRESHOLD) {
      if (isSecondaryVisible) {
        slideImages(secondaryImage, primaryImage, 'right');
        updatePaginationDots(paginationDots, 0);
      } else {
        slideImages(primaryImage, secondaryImage, 'right');
        updatePaginationDots(paginationDots, 1);
      }
    }

    isDragging = false;
    currentElement = null;
  }

  function slideImages(outgoingImage, incomingImage, direction) {
    if (!outgoingImage || !incomingImage) return;

    const incomingStart = direction === 'left' ? '100%' : '-100%';
    const outgoingEnd = direction === 'left' ? '-100%' : '100%';

    incomingImage.style.transform = `translateX(${incomingStart})`;
    incomingImage.style.opacity = '1';
    incomingImage.style.transition = 'none';
    
    incomingImage.offsetHeight;

    const transition = `transform ${TRANSITION_DURATION}ms ease-in-out, opacity ${TRANSITION_DURATION}ms ease-in-out`;
    
    outgoingImage.style.transition = transition;
    outgoingImage.style.transform = `translateX(${outgoingEnd})`;
    outgoingImage.style.opacity = '0';

    incomingImage.style.transition = transition;
    incomingImage.style.transform = 'translateX(0)';
    incomingImage.style.opacity = '1';

    setTimeout(() => {
      outgoingImage.style.transform = '';
      outgoingImage.style.transition = '';
      outgoingImage.style.opacity = '0';
      
      incomingImage.style.transform = '';
      incomingImage.style.transition = '';
    }, TRANSITION_DURATION);
  }

  function showImageByIndex(container, index) {
    if (!container) return;

    const primaryImage = container.querySelector('.new-pc-img');
    const secondaryImage = container.querySelector('.secondary-image');
    const paginationDots = container.querySelectorAll('.pagination-dot-cont');
    
    if (!primaryImage || !secondaryImage || paginationDots.length !== 2) return;

    const isSecondaryVisible = parseFloat(getComputedStyle(secondaryImage).opacity) > 0.5;
    const currentIndex = isSecondaryVisible ? 1 : 0;

    if (currentIndex === index) return;

    const direction = index > currentIndex ? 'left' : 'right';

    if (index === 0) {
      slideImages(secondaryImage, primaryImage, direction);
    } else {
      slideImages(primaryImage, secondaryImage, direction);
    }

    updatePaginationDots(paginationDots, index);
  }

  function updatePaginationDots(dots, activeIndex) {
    if (!dots || dots.length !== 2) return;
    
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  function handleDotClick(e) {
    if (window.disableProductImageSlider) return;
    
    const dot = e.target.closest('.pagination-dot-cont');
    if (!dot) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const container = dot.closest('.product-grid-item__image--secondary');
    if (!container) return;

    const allDots = container.querySelectorAll('.pagination-dot-cont');
    const index = Array.from(allDots).indexOf(dot);

    if (index !== -1) {
      showImageByIndex(container, index);
    }
  }

  function preventLinkNavigation(e) {
    if (window.disableProductImageSlider) return;
    
    const target = e.target;
    const isPaginationClick = target.closest('.pagination-dots-mobile');
    
    if (isPaginationClick && e.target.tagName === 'A') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    
    if (isPaginationClick) {
      const anchor = target.closest('a');
      if (anchor) {
        e.preventDefault();
      }
    }
  }

  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchmove', handleTouchMove, { passive: false });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });
  document.addEventListener('click', handleDotClick);
  
  document.addEventListener('click', preventLinkNavigation, { capture: true });

  window.addEventListener('beforeunload', function() {
    document.removeEventListener('touchstart', handleTouchStart);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
    document.removeEventListener('click', handleDotClick);
    document.removeEventListener('click', preventLinkNavigation, { capture: true });
  });
})();
